<template>
    <div class="LoginBtn__warp">
        <el-button v-if="!userInfo || userInfo.anonymous" @click="toLoginPath" size="medium">登录</el-button>
        <el-dropdown v-if="userInfo && !userInfo.anonymous" placement="bottom" @command="handleCommand">
            <!-- @click="handleCommand('profile')"  -->
            <button type="button" class="Button Button--plain"
                style="display:flex;align-items:center;color:black;margin-left: 16px;color:white;">
                {{ userInfo.name }}&nbsp;&nbsp;
                <avatar :size="36" :url="userInfo.avatar"></avatar>
            </button>
            <el-dropdown-menu slot="dropdown">
<!--                 <el-dropdown-item command="profile" icon="el-icon-user">我的主页</el-dropdown-item>-->
                 <el-dropdown-item command="toMyInformation" icon="el-icon-user">个人信息</el-dropdown-item>
                 <!-- <el-dropdown-item command="toChangePassword" icon="el-icon-setting">修改密码</el-dropdown-item> -->
                <el-dropdown-item command="logout" icon="el-icon-switch-button">退出登录</el-dropdown-item>
            </el-dropdown-menu>
        </el-dropdown>
    </div>
</template>

<script>
import { Avatar } from '@zkwq/business'
import { outLogin} from '../util/login'

export default {
    name: 'LoginBtn',
    components: { Avatar },
    data () {
        return {
            userInfo: {}
        }
    },
    props: {  //父组件属性
        users: {
            type: Object,
            default: null
        },
    },
    users: {
        value(newValue, oldValue) {
            //console.log(newValue);
            this.userInfo = newValue;
        },
    },
    mounted(){
        this.userInfo = this.users;
    },
    methods: {
        handleCommand (command) {
            if (command === 'logout') {
                outLogin();
            } else if (command == 'profile') {
                this.$router.push(`/microapp/profile`)
            }else if (command == 'toMyInformation') {
              this.$router.push(`/myInformation`)
          }else if(command=='toChangePassword'){
              this.$router.push(`/changePassword`)
            }
        },
        toLoginPath () {
            this.$router.push(`/login`)
        }
    }
}
</script>

<style scoped>
.LoginBtn__warp {
    width: 100%;
    height: auto;
    overflow: hidden;
    margin-top: 0px;
}
</style>